var map = {
	"./eye-0.png": "5pcJ",
	"./eye-1.png": "wLQV",
	"./icon-phone.png": "mXzI",
	"./icon-qy.png": "X839",
	"./img-qywx.png": "ITeC",
	"./img-zixun.png": "/fyZ",
	"./img-zixun2.png": "fLYQ",
	"./newCode.png": "54gq",
	"./newCode2.png": "QXCG",
	"./rebate.png": "Xhid",
	"./rebate.svg": "4d6p"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0tcK";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image ^\.\/.*$
// module id = 0tcK
// module chunks = 1